// Human-readable labels for StockMovement reasons (mirrors the backend
// MOVEMENT_REASON_LABELS in constants/inventory.js). The stored value is the
// short machine code; this maps it to display text.
export const MOVEMENT_REASON_LABELS: Record<string, string> = {
  opening: "Opening Stock",
  grn: "Goods Receipt (GRN)",
  grn_reversed: "GRN Reversed",
  transfer_out: "Transfer Out",
  transfer_in: "Transfer In",
  transfer_reversed: "Transfer Reversed",
  sale: "Sale",
  production_consume: "Production Consume",
  production_yield: "Production Yield",
  wastage: "Wastage",
  adjustment: "Adjustment",
  return: "Return",
};

export const movementReasonLabel = (code: string): string => MOVEMENT_REASON_LABELS[code] || code;
